import { IProduct, ISalesDocument } from '@cemex-core/cmx-api';
import { ISalesDocument as InvoiceSalesDocument } from '@cemex-core/cmx-api/models/sales-document-management';
import { Action } from '@ngrx/store';
import { OneClickContractType } from '../models/one-click-contract.model';

export enum OneClickContractActionTypes {
  LOAD_CONTRACTS = '[One Click] Load payments',
  LOAD_CONTRACTS_COMPLETE = '[One Click] Load contracts completed',
  SELECT_CONTRACT = '[One Click] Select contract',
  SELECT_CONTRACT_TYPE = '[One Click] Select contract type',
  LOAD_INVOICES_COMPLETE = '[One Click] Load invoices completed',
  SELECT_INVOICE = '[One Click] Select invoice',
  RESET = '[One Click] Contracts reset',
}

export class OneClickLoadContractsAction implements Action {
  readonly type = OneClickContractActionTypes.LOAD_CONTRACTS;

  constructor(public payload: IProduct, public index: number) {}
}

export class OneClickLoadContractsCompleteAction implements Action {
  readonly type = OneClickContractActionTypes.LOAD_CONTRACTS_COMPLETE;

  constructor(public payload: ISalesDocument[], public index: number) {}
}

export class OneClickSelectContractAction implements Action {
  readonly type = OneClickContractActionTypes.SELECT_CONTRACT;

  constructor(public payload: ISalesDocument, public index: number) {}
}

export class OneClickSelectContractTypeAction implements Action {
  readonly type = OneClickContractActionTypes.SELECT_CONTRACT_TYPE;

  constructor(public payload: OneClickContractType, public index: number) {}
}
export class OneClickLoadInvoicesCompleteAction implements Action {
  readonly type = OneClickContractActionTypes.LOAD_INVOICES_COMPLETE;

  constructor(public payload: InvoiceSalesDocument[], public index: number) {}
}

export class OneClickSelectInvoiceAction implements Action {
  readonly type = OneClickContractActionTypes.SELECT_INVOICE;

  constructor(public payload: InvoiceSalesDocument, public index: number) {}
}

export class OneClickResetContractAction implements Action {
  readonly type = OneClickContractActionTypes.RESET;

  constructor() {}
}

export type OneClickContractActions =
  | OneClickLoadContractsAction
  | OneClickLoadContractsCompleteAction
  | OneClickSelectContractAction
  | OneClickSelectContractTypeAction
  | OneClickResetContractAction
  | OneClickLoadInvoicesCompleteAction
  | OneClickSelectInvoiceAction;
